
import React from 'react';
import { AlertCircle } from 'lucide-react';

interface SecurityNoticeProps {
  showNotice: boolean;
}

const SecurityNotice: React.FC<SecurityNoticeProps> = ({ showNotice }) => {
  if (!showNotice) return null;
  
  return (
    <div className="p-3 bg-blue-500/10 border border-blue-200/20 rounded-md mt-4">
      <div className="flex items-start space-x-2">
        <AlertCircle size={16} className="text-blue-500 mt-0.5 flex-shrink-0" />
        <div className="text-sm">
          <p className="text-blue-500 font-medium">Optimizing crawl for website security</p>
          <p className="text-muted-foreground">Some websites have protective measures against automated access. We're using browser-like requests while respecting the site's security settings.</p>
        </div>
      </div>
    </div>
  );
};

export default SecurityNotice;
